import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { BarChart3, Inbox, Video } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReportsEmptyStateProps {
  type: 'no-video' | 'no-data' | 'no-strategies';
  onCreateStrategy?: () => void;
  onClearFilters?: () => void;
}

export const ReportsEmptyState: React.FC<ReportsEmptyStateProps> = ({
  type,
  onCreateStrategy,
  onClearFilters,
}) => {
  useLanguage();
  if (type === 'no-video') {
    return (
      <div className="flex flex-col items-center justify-center text-center p-12 min-h-[400px]">
        <div className="rounded-full bg-primary/10 p-6 mb-6">
          <Video className="w-12 h-12 text-primary" />
        </div>
        <h3 className="text-xl font-semibold mb-2">{translateInterfaceText("Selecione um vídeo")}</h3>
        <p className="text-muted-foreground max-w-md">
          {translateInterfaceText("Escolha um vídeo acima para visualizar os relatórios de captura.")}</p>
      </div>
    );
  }

  if (type === 'no-data') {
    return (
      <div className="flex flex-col items-center justify-center text-center p-12 min-h-[400px]">
        <div className="rounded-full bg-primary/10 p-6 mb-6">
          <Inbox className="w-12 h-12 text-primary" />
        </div>
        <h3 className="text-xl font-semibold mb-2">{translateInterfaceText("Nenhum registro encontrado")}</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          {translateInterfaceText("Não há capturas para os filtros aplicados. Tente ajustar os filtros ou selecione outro período.")}</p>
        {onClearFilters && (
          <Button variant="outline" onClick={onClearFilters}>
            {translateInterfaceText("Limpar Filtros")}</Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center text-center p-12 min-h-[400px]">
      <div className="rounded-full bg-primary/10 p-6 mb-6">
        <BarChart3 className="w-12 h-12 text-primary" />
      </div>
      <h3 className="text-xl font-semibold mb-2">{translateInterfaceText("Relatórios de Captura")}</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        {translateInterfaceText("Os relatórios de performance ficarão disponíveis aqui após a criação de estratégias.")}</p>
      {onCreateStrategy && (
        <Button onClick={onCreateStrategy}>
          {translateInterfaceText("Criar Captura")}</Button>
      )}
    </div>
  );
};
